import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
// import './App.scss';
import Masonry from 'react-masonry-css'

const breakpointColumnsObj = {
  default: 2,
  1100: 2,
  700: 2,
  576: 1
};





const About = (props) => {
      
    if (props.page) {
      const imageList = props.page.acf.about_images.map(images => {
        if (images.about_image) {
          return ( 
            <div class="grid-item grid-item--work">	
              <div class="inner">
                <div class="grid-item__image">
                  <img src={images.about_image.sizes.large} />
                </div>
              </div>
            </div>
          );
        }
      }); 
      return (
        <div className="home-page">
            <div className="row">
              <div className="col-12">
                <div className="intro-text" dangerouslySetInnerHTML={{__html: props.page.content.rendered}}>
                </div>
              </div>
              <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column">
                {imageList}
              </Masonry>
              
            </div>
        </div>
      )
    } else {
      return (
        <div className="intro-text">
          <p>loading...</p>        
        </div>
      )
    }
}

export default About;
